
export const BookingPageModes = {
    'CHECK_IN': 'CHECK_IN',
    'CHECK_OUT': 'CHECK_OUT',
    'ONLY_NEW': 'ONLY_NEW'
}
